import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "home",
    on: {
      "click": _vm.handleGlobalClick
    }
  }, [_c('Header', {
    ref: "headerRef",
    attrs: {
      "isClassifyBtn": false,
      "isClassify": true
    },
    on: {
      "search-triggered": function searchTriggered($event) {
        _vm.showStauts = !_vm.showStauts;
      },
      "handTips": _vm.handTips
    }
  }), _c('div', {
    staticClass: "custom-label content"
  }, [_c('div', {
    staticClass: "custom-left"
  }, [_vm.bannerList.length > 0 ? _c('div', {
    staticClass: "banner"
  }, [_c('el-carousel', {
    attrs: {
      "height": "224px",
      "arrow": "always",
      "loop": true
    }
  }, _vm._l(_vm.bannerList, function (item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.imagePath.cdnFilePathPc
      },
      on: {
        "click": function click($event) {
          return _vm.goDetails(item.jumpUrl);
        }
      }
    })]);
  }), 1)], 1) : _vm._e()]), _c('div', {
    staticClass: "custom-right",
    class: {
      active: _vm.bannerList.length == 0
    }
  }, [_c('div', {
    staticClass: "right-top",
    on: {
      "click": function click($event) {
        return _vm.$router.push('/consumables');
      }
    }
  }, [_c('h3', [_vm._v("定制标签")]), _vm._m(0)]), _c('div', {
    staticClass: "right-bottom"
  }, [_c('div', {
    staticClass: "custom-content"
  }, [_c('h3', [_vm._v(" 快速查找标签纸 "), _c('img', {
    staticClass: "answer",
    attrs: {
      "src": require("@/assets/images/custom-doubt.png"),
      "alt": ""
    },
    on: {
      "click": function click($event) {
        _vm.isShowPaper = !_vm.isShowPaper;
      }
    }
  }), _vm.isShowPaper ? _c('div', {
    staticClass: "tagpaper"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/tagimg.png"),
      "alt": ""
    }
  }), _c('i', {
    staticClass: "iconfont icondelete",
    on: {
      "click": function click($event) {
        _vm.isShowPaper = false;
      }
    }
  })]) : _vm._e()]), _c('ul', _vm._l(_vm.printSizeList, function (item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function click($event) {
          return _vm.goSearch(item.printSize);
        }
      }
    }, [_vm._v(" " + _vm._s(item.printSize) + " ")]);
  }), 0)]), _c('div', {
    staticClass: "custom-lookup"
  }, [_c('div', {
    staticClass: "lookup-width"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchWidth,
      expression: "searchWidth"
    }],
    attrs: {
      "type": "number",
      "placeholder": "宽度 (mm)"
    },
    domProps: {
      "value": _vm.searchWidth
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.searchWidth = $event.target.value;
      }
    }
  })]), _c('em', [_vm._v("*")]), _c('div', {
    staticClass: "lookup-height"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchHeight,
      expression: "searchHeight"
    }],
    attrs: {
      "type": "number",
      "placeholder": "高度 (mm)"
    },
    domProps: {
      "value": _vm.searchHeight
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.searchHeight = $event.target.value;
      }
    }
  })]), _c('span', {
    class: [_vm.searchWidth && _vm.searchHeight ? 'acvivebt' : 'bt'],
    on: {
      "click": _vm.goClassify
    }
  }, [_vm._v("查找")])])])]), _vm.showStauts ? _c('div', {
    ref: "deviceSelectorRef",
    staticClass: "device-selector-container"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("选机型自动匹配的耗材")]), _c('div', {
    staticClass: "header-botton",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.clearSelection.apply(null, arguments);
      }
    }
  }, [_vm._v("清除选择")])]), _c('div', {
    staticClass: "search-bar"
  }, [_c('el-autocomplete', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入设备型号查询",
      "prefix-icon": "el-icon-search"
    },
    on: {
      "input": _vm.handInput
    },
    model: {
      value: _vm.searchText,
      callback: function callback($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }, [_vm.searchText ? _c('i', {
    staticClass: "el-icon-edit el-icon-error",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handleIconClick.apply(null, arguments);
      }
    },
    slot: "suffix"
  }) : _vm._e()])], 1), _c('div', {
    staticClass: "device-grid-wrapper"
  }, _vm._l(_vm.devices, function (item, index) {
    return _c('div', {
      key: item.deviceId,
      staticClass: "wrapper-content"
    }, [_c('div', {
      staticClass: "device-card",
      class: {
        'is-selected': _vm.selectedDeviceId === item.deviceId,
        'is-current-use': item.isCurrent
      },
      on: {
        "click": function click($event) {
          return _vm.selectDevice(item);
        }
      }
    }, [_c('div', {
      staticClass: "device-image"
    }, [_c('img', {
      attrs: {
        "src": item.imgPath
      }
    })]), _c('div', {
      staticClass: "device-name"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), item.useStatus == 1 ? _c('div', {
      staticClass: "current-use-tag"
    }, [_vm._v("当前使用")]) : _vm._e(), _vm.selectedDeviceId === item.deviceId ? _c('div', {
      staticClass: "selected-icon"
    }, [_c('i', {
      staticClass: "el-icon-success"
    })]) : _vm._e()])]);
  }), 0)]) : _vm._e()]), _c('classify', {
    ref: "classifyRef",
    on: {
      "handTypeId": _vm.handTypeId
    }
  }), _c('el-dialog', {
    staticClass: "flash-dialog",
    attrs: {
      "visible": _vm.isFLash,
      "width": "30%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.isFLash = $event;
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.appSourceUrl
    },
    on: {
      "click": function click($event) {
        return _vm.popularizeReceive('isFlash');
      }
    }
  }), _c('i', {
    staticClass: "iconfont iconClose close",
    on: {
      "click": _vm.closeSale
    }
  })]), _vm.smallSourceUrl !== '' ? _c('div', {
    staticClass: "smallsale"
  }, [_c('img', {
    attrs: {
      "src": _vm.smallSourceUrl
    },
    on: {
      "click": _vm.popularizeReceive
    }
  })]) : _vm._e(), _c('BackTop'), _c('Footer'), _c('Regular', {
    ref: "RegularRef"
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('p', [_vm._v("logo印刷等特殊标签定制"), _c('i', {
    staticClass: "iconfont icongengduoxiangqing-copy"
  })]);
}];
export { render, staticRenderFns };